<template>
  <div id="container" class="container">
    <div id="title" class="title">Kyohei Kondo's Portfolio</div>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";

export default defineComponent({
  props: {},
  setup() {
    const title = ref("Works");

    window.setTimeout(() => {
      const container = document.getElementById("container");
      container.classList.add("fade-out");
    }, 1000);

    window.setTimeout(() => {
      const container = document.getElementById("container");
      console.log(container)
      console.log(container == false)
      if (container) {
        container.remove();
      }
    }, 3000);

    return { title };
  },
});
</script>

<style scoped>
.container {
  position: fixed;
  top: 0;
  height: 100vh;
  width: 100%;
  background: #2c3e50;
  z-index: 999;
  -webkit-transition: all 2s;
  -moz-transition: all 2s;
  -ms-transition: all 2s;
  -o-transition: all 2s;
  transition: all 2s;
  opacity: 1;
}

.title {
  position: fixed;
  color: #ffffff;
  font-size: 70px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.fade-out {
  opacity: 0;
  height: 0;
}
</style>